export default __webpack_public_path__ + "static/media/ic_picture.762c737f.svg";